import { PostProperties } from "../types";
import image from "../img/lostGemDelanoSmith.jpg";

const post: PostProperties = {
  id: 19,
  title: "Delano Smith - Cocobeach, Paris (19.07.2015)",
  content:
    "The absolutely exceptional house and techno producer Delano Smith, graces the decks of Cocobeach, Paris in 2015. In October 2022, the producer has been diagnosed with Thymic Carcinoma which is a rare form of cancer. A fundraiser has been launched by his friends and family in order to help the payment of medical bills.",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/delano-smith-cocobeach-paris-19072015",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Изключителният продуцент на хаус и техно музика Delano Smith застава зад пулта в Cocobeach, Париж, през 2015 г. През октомври 2022 г. продуцентът е диагностициран с тимичен карцином – рядка форма на рак. Приятелите и семейството му са организирали набиране на средства за покриване на медицинските разходи.",
  },
};

export default post;
